













import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SettingItem extends Vue {
  @Prop({ required: false, default: null })
  private title!: string;
}
